// src\themes\tolica\layouts\default.tsx
import { ReactNode } from 'react';
import Header from '../elements/Header/Header';
import Footer from '../elements/footer/Footer';
import { OrganizationSchema } from '@/components/main/seo/OrganizationSchema';
import SupportWidget from '../components/AdminSupportButton';
import { getSettings } from '@/core/lib/api/main/setting';
import MainContentWrapper from '../elements/Header/MainContentWrapper';

export default async function MainLayout({
    children,
}: Readonly<{
    children: ReactNode;
}>) {
    // قبلاً از api/admin/settings/show (یه endpoint ادمین‌محور که نیاز به
    // CSRF هم داشت) استفاده می‌شد، در حالی‌که این فقط یه سوییچ عمومیه که از
    // طریق api/pub-setting هم در دسترسه؛ برای هر بازدیدکننده‌ی مهمون، اون
    // endpoint تقریباً همیشه با 401 رد می‌شد (خود کد هم با .catch(()=>null)
    // این شکست رو پیش‌بینی کرده بود) و فقط دو رفت‌وبرگشت اضافه به بک‌اند بود.
    const settingsRes = await getSettings().catch(() => null);
    const isSupportActive = settingsRes?.support_widget_active !== 'deactive';

    return (
        <>
            <OrganizationSchema />
            <Header />
            <main className="flex bg-primary-0 flex-col bg-r min-h-[calc(100vh-72px)]">
                <MainContentWrapper>{children}</MainContentWrapper>
            </main>
            <SupportWidget active={isSupportActive} />
            <Footer />
        </>
    );
}